import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/nl'

// Netcode init
window.API_URL = "https://www.rememberme.nl/ptapi";

if (process.env.REACT_APP_STAGE === "dev") {
    window.API_URL = "http://dev.rememberme.net/ptapi";
    console.warn('********* Using development settings for API *********');
}

axios.defaults.baseURL = window.API_URL;
axios.defaults.headers.common['X-Webcrown'] = 'ptapi';
axios.defaults.withCredentials = true;

// Moment default locale
moment.locale('nl');

// Touch device detection
function is_touch_device() {
    try {
        let prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

        let mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || (typeof window.DocumentTouch !== "undefined" && document instanceof window.DocumentTouch)) {
            return true;
        }

        return mq(['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(''));
    } catch (e) {
        console.error('(Touch detect failed)', e);
        return false;
    }
}

window.ptTouch = is_touch_device();

// App root
ReactDOM.render(<App/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js